

































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import 'leaflet-polylinedecorator';
import L from 'leaflet';

import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
import LControlHeightGraph from 'vue2-leaflet-height-graph/dist/Vue2LeafletHeightGraph.common.js';
import LControlFullscreen from 'vue2-leaflet-fullscreen';

import { mapState } from "vuex";
import { createDistanceMarkers } from '~/utils/posts.js';
import { formatDistance } from '~/utils/units.js';

import LayersOutline from '~/components/icons/LayersOutline.vue';
import NavigationOutline from '~/components/icons/NavigationOutline.vue';
import XSolid from '~/components/icons/XSolid.vue';
import LocalisationDestinationCard from '~/components/cards/LocalisationDestinationCard.vue';
import EventCard from '~/components/cards/EventCard.vue';
import ProviderCard from '~/components/cards/ProviderCard.vue';
import RefreshOutline from '~/components/icons/RefreshOutline.vue';
import DotsHorizontalSolid from '~/components/icons/DotsHorizontalSolid.vue';
import CartOutline from '~/components/icons/CartOutline.vue';
import TicketOutline from '~/components/icons/TicketOutline.vue';
import BedSolid from '~/components/icons/BedSolid.vue';
import EatOutline from '~/components/icons/EatOutline.vue';
import ServiceOutline from '~/components/icons/ServiceOutline.vue';
import POIModal from '~/components/modals/POIModal.vue';
import EmergencyOutline from "~/components/icons/EmergencyOutline.vue";
import { ignScan25Url, ignStandardUrl } from "~/utils/map";
import OpenMap from "~/components/icons/OpenMap.vue";
import CloseMap from "~/components/icons/CloseMap.vue";
import { colorMappings } from "~/utils/routes";

type ProviderIcon = {id: string, icon: Function, checked: boolean};

@Component({
  components: {
    OpenMap,
    CloseMap,
    LayersOutline,
    NavigationOutline,
    XSolid,
    'v-marker-cluster': Vue2LeafletMarkerCluster,
    LocalisationDestinationCard,
    EventCard,
    RefreshOutline,
    ProviderCard,
    'l-heightgraph': LControlHeightGraph,
    LControlFullscreen,
    DotsHorizontalSolid,
    CartOutline,
    TicketOutline,
    BedSolid,
    EatOutline,
    EmergencyOutline,
    POIModal,
  },

  computed: {
    ...mapState([
      'iframeMode',
    ]),
  },
})

export default class RouteMap extends Vue {
    @Prop(String) customHeight: '';
    @Prop(Boolean) hideControls: false;
    @Prop(Object) route: any;
    @Prop(Object) start: Types.Location | null;
    @Prop(Object) end: Types.Location | null;
    @Prop(Array) providers: Types.Provider[];
    @Prop(Object) topography: Types.Geojson;
    @Prop(Boolean) isInPrintMode: false;
    @Prop(String) routeColor: '#1F2A44';
    @Prop(String) routeType: 'ROUTE' | 'SPOT';
    @Prop(Array) pois: Types.RoutePoi[];
    @Prop(String) destinationCountryCode: string;

    $refs: {
      map: any,
      zoomContainer: any,
    }

    listOfProviderIcons: Array<ProviderIcon> = [
      {
        id: 'FOOD',
        icon: EatOutline,
        checked: false,
      },
      {
        id: 'SHOP',
        icon: CartOutline,
        checked: false,
      },
      {
        id: 'HOSTING',
        icon: BedSolid,
        checked: false,
      },
      {
        id: 'TODOTOSEE',
        icon: TicketOutline,
        checked: false,
      },
      {
        id: 'SERVICE',
        icon: ServiceOutline,
        checked: false,
      },
      {
        id:'EMERGENCY',
        icon: EmergencyOutline,
        checked:false,
      },
    ];

    panCustom: number[] = process.client ? window.innerWidth >= 768 ? [300, 100] : [200, 100] : [300, 100];
    formatDistance = formatDistance;

    providersListIsOpen: boolean = true;
    showPOIModal: boolean = false;
    focusedPoi: Types.RoutePoi | null = null;

    startingPointIcon = this.$L.icon({
      iconUrl: '/icons/Pin_start.svg',
      iconSize: [32, 32],
      className: 'resetMarkerClass',
    });

    spotPointIcon = this.$L.icon({
      iconUrl: '/icons/PinSpot.svg',
      iconSize: [32, 32],
      className: 'resetMarkerClass removeBackground',
    });

    endingPointIcon = this.$L.icon({
      iconUrl: '/icons/Pin_arrival.svg',
      iconSize: [32, 32],
      className: 'resetMarkerClass',
    });

    get isFullscreen (): boolean {
      return this.$store.state.explorer.toggleRouteMap;
    }

    get mapIcon () {
      return this.isFullscreen ? 'CloseMap' : 'OpenMap';
    }

    get heightGraphOptions () {
      return {
        expandControls: false,
        width: this.printMode ? 1125 : this.heightgraphWidth,
        height: this.$store.state.explorer.toggleRouteMap ? 160 : 200,
        "position": "bottomleft",
        margins: {
          top: 15,
          right: 20,
          bottom: 30,
          left: 60,
        },
        mappings: this.translateMappings(),
        graphStyle: {
          'fill': '#FFFFFF',
          'fill-opacity': 1,
          'stroke-width': '1px',
        },
        translation: {
          distance: this.$t('explorer.routes.heightgraph.distance'),
          elevation: this.$t('explorer.routes.heightgraph.elevation'),
          segment_length: this.$t('explorer.routes.heightgraph.segmentLength'),
          type: this.$t('explorer.routes.heightgraph.type'),
          legend: 'Legend',
        },
      };
    }

    clickedIcon: string = '';
    providersIcon = this.$L.icon({
      iconUrl: '/icons/PinProviders.svg',
      iconSize: [50, 50],
      iconAnchor: [16, 37],
      className: 'providerIcon',
    })

    defaultHeight: string = '550px';
    isXsDevice: boolean = false;
    isSettingsOpened: boolean = false;
    tileProviders: Types.TileProvider = [
      {
        id: 2,
        name: 'Outdoor',
        url: `https://api.maptiler.com/maps/outdoor/{z}/{x}/{y}.png?key=${this.$config.MAPTILER_KEY}`,
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },
      {
        id: 1,
        name: 'Streets',
        url: `https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=${this.$config.MAPTILER_KEY}`,
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },
      {
        id: 3,
        name: 'Satellite',
        url: `https://api.maptiler.com/tiles/satellite-v2/{z}/{x}/{y}.jpg?key=${this.$config.MAPTILER_KEY}`,
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },
      {
        id: 4,
        name: 'IGN Standard',
        url: ignStandardUrl,
        attribution : "IGN-F/Géoportail",
      },
      {
        id: 5,
        name: 'IGN Scan 25',
        url: ignScan25Url,
        attribution : "IGN-F/Géoportail",
      },
    ];

    currentTile = this.tileProviders[0]
    picked = this.tileProviders[0].name;
    posts: Array<{value: number, coordinate: {long: number, lat: number}}> = [];
    topo: any = [];
    iframeMode: null;

  clusterOptions = {
    removeOutsideVisibleBounds: false,
    polygonOptions: {
      fillColor: '#1F2A44',
      color: '#1F2A44',
    },
  };

  toggleFullWidth () {
    this.$store.commit('explorer/SET_TOGGLE_ROUTE_MAP_FULL_SCREEN', !this.isFullscreen);

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }

  handleKeydown (e: KeyboardEvent) {
    if (e.key === 'Escape' && this.$store.state.explorer.toggleRouteMap) {
      this.toggleFullWidth();
    }
  }

    /*
    This method is useful only in print mode, because a side-effect causes
    a bug inside the heightgraph plugin. Updating the map height
    directly after mounted will prevent the map to be mounted without
    this plugin.
  */
    @Watch('customHeight')
  updateMap (val: string) {
    this.defaultHeight = val;
    setTimeout(() => {
      this.$refs.map.mapObject.invalidateSize();
      this.$root.$emit('has-updated-height', true);
    }, 300);
  }

    /* Returns a reactive boolean about this.isInPrintMode prop */
    get printMode () {
      return this.isInPrintMode;
    }

    /*
      Will return the list of providers filters if this.providersListIsOpen data
      boolean is true
    */
    get providersDisplay () {
      if (this.providersListIsOpen) return this.listOfProviderIcons;
      return [];
    }

    /*
      This computed will filter inside this.providersDisplay, and if both
      types and ids match, we display the providers filtered
    */
    get providersToDisplay () {
      const array: Types.Provider[] = [];

      /* eslint array-callback-return: 0 */
      const allFalsy: boolean = this.listOfProviderIcons?.every((icon: ProviderIcon) => !icon.checked);
      if (allFalsy) return [];

      this.providers.map((s: Types.Provider) => {
        this.listOfProviderIcons.map((f: ProviderIcon) => {
          if (s.type === f.id) {
            if (f.checked) {
              array.push(s);
            }
          }
        });
      });
      return array;
    }

    /*
      This computed will return a width for the heightgraph plugin to be init
      in a size that will be matching device width
    */
    get heightgraphWidth () {
      if (process.client) {
        const container = document.querySelector('#heightgraph-container');
        if (container) {
          return container.clientWidth;
        }
        if (window.innerWidth <= 1024 && window.innerWidth > 768) return 500;
        if (window.innerWidth <= 768) return 250;
        return 800;
      }
      return 800;
    }

    /* If a customHeight is provided by parent, we update the map height */
    created () {
      if (this.customHeight) {
        this.defaultHeight = this.customHeight;
      }

      if (this.destinationCountryCode === "FR") {
        this.currentTile = this.tileProviders[3];
        this.picked = this.currentTile.name;
      }
    }

    // replace each mapping text by translation
    translateMappings () {
      return Object.fromEntries(
        Object.entries(colorMappings).map(([extraType, mappings]) => [
          extraType,
          Object.fromEntries(
            Object.entries(mappings).map(([key, val]) => [
              key,
              { ...val, text: this.$t('explorer.routes.segments.' + extraType + '.' + val.text.toLowerCase()) },
            ]),
          ),
        ]),
      );
    }

    beforeMount () {
      window.L = L;
    }

    mounted () {
      // This method is triggered to handle map behavior on user scroll based on
      // its window innerWidth
      this.handleWheel();

      // Settings on button (need a ledge setTimeout to let map component load)
      this.$nextTick(() => {
        // Calls the method that will update style of zoom buttons
        this.stylizeZoomControl();

        // In SSR mode, we create the geoJson of the track, the associated
        // heightgraph, and we will fit bounds on the route track.
        if (this.routeType === 'ROUTE') {
          this.centerMapOnGeoJson(this.route);
        }
      });

      // Listening to resize event to handle map behavior
      if (process.client) {
        window.addEventListener('resize', this.handleWheel, false);
        window.addEventListener('keydown', this.handleKeydown);
      }

      // If we are in iframeMode, we close by default
      if (this.iframeMode) {
        this.providersListIsOpen = false;
      }
    }

    /*
      When leaving the page, we force delete the heightgraph, as it can
      sometimes have a weird side-effect where the heightgraph doesn't reload
      between two pages that contains the RouteMap component
    */
    beforeDestroy () {
      if (this.topo && this.topo.length > 0) {
        this.$refs.map.mapObject.removeControl(this.topo);
        this.topo = [];
      }

      if (process.client) {
        window.removeEventListener('keydown', this.handleKeydown);
      }
    }

    destroyed () {
      // Remove resize event listener when destroying component
      if (process.client) window.removeEventListener('resize', this.handleWheel);
    }

    /*
      Toggle maps settings
    */
    toggleMapSettings () {
      this.isSettingsOpened = !this.isSettingsOpened;
    }

    /*
      Change layer of the current map
    */
    changeTile (index: number) {
      this.currentTile = this.tileProviders[index];
    }

    /* This method applies custom styles to zoom buttons of map. */
    stylizeZoomControl () {
      if (process.client) {
        const plus: any = document.getElementsByClassName("leaflet-control-zoom-in")[0];
        const minus: any = document.getElementsByClassName("leaflet-control-zoom-out")[0];

        // content
        if (!this.isInPrintMode) {
          plus.innerHTML = "";
          minus.innerHTML = "";
        }

        if (this.hideControls) {
          this.$refs.map.mapObject.dragging.disable();

          document.querySelectorAll('.leaflet-control-container').forEach((item: any) => {
            item.style.display = 'none';
          });
        } else if (this.customHeight) {
          document.querySelectorAll('.leaflet-top.leaflet-right').forEach((item: any) => {
            item.style.marginTop = '1rem';
            item.style.marginRight = '1.5rem';
          });
        } else {
          document.querySelectorAll('.vue2leaflet-map').forEach((item: any) => {
            item.style.borderRadius = '0.5rem';
          });
        }
      }
    }

    /*
      When map is ready, and if map contains a single marker that is a spot,
      we will fit bounds on the coordinates of the spot
    */
    fitSpotBounds () {
      if (this.routeType === 'SPOT' && this.start !== null) {
        this.$refs.map.mapObject.fitBounds([
          [this.start.latitude, this.start.longitude],
        ]);
      }
    }

    /*
      This method will create:
      - A polyline based on route datas
      - Posts markers representing route distances with user preferred unit
      - Polyline decorator (arrows) representing the direction of the track
    */
    centerMapOnGeoJson (val: any) {
      if (process.client) {
        if (this.route) {
          const leafletInstance: any = window.L;

          // We extend Leaflet Polyline class to get the distance of the track
          leafletInstance.Polyline = leafletInstance.Polyline.include({
            getDistance (system: string) {
              var mDistanse = 0;
              var length = this._latlngs.length;
              for (var i = 1; i < length; i++) {
                mDistanse += this._latlngs[i].distanceTo(this._latlngs[i - 1]);
              }
              if (system === 'imperial') {
                return mDistanse / 1609.34;
              } else {
                return mDistanse / 1000;
              }
            },
          });

          // Get polyline object to create a polyline of the track,
          // and the posts in a second time. We need the two formats as Leaflet
          // methods aren't working the same way
          const polyline = this.getPolyline();

          // Adding the polyline to the map, with color handle and custom weight.
          const polylineOnMap: any = leafletInstance.polyline(polyline.onlyNumber, { color: this.routeColor });

          if (!this.isInPrintMode) {
            // Using the extended method to get polyline total distance with
            // user preferred unit.
            const distance: number = leafletInstance.polyline(polyline.onlyNumber).getDistance(this.$cookies.get('unit'));

            // Creating posts with polyline object structure that contains
            // { lat: number, lng: number } to create markers on the polyline.
            // The distance between markers is handled in the createDistanceMarkers
            // util.
            this.posts = createDistanceMarkers(polyline.withObjects, distance, this.$cookies.get('unit') === 'metric');

            polylineOnMap.addTo(this.$refs.map.mapObject);

            // Add the arrows polyline decorator to the map
            // using extend polylineDecorator method.
            leafletInstance.polylineDecorator(polylineOnMap, {
              patterns: [{
                offset: 50,
                repeat: 75,
                symbol: leafletInstance.Symbol.arrowHead({
                  pixelSize: 10,
                  polygon: false,
                  pathOptions: {
                    color: '#1F2A44',
                    stroke: true,
                  },
                }),
              }],
            }).addTo(this.$refs.map.mapObject);
          }

          // Fits the map to the created poyline
          this.$refs.map.mapObject.fitBounds(polylineOnMap.getBounds());
        }
      }
    }

    /*
      Util method that will return a object with twice the polyline, but in
      two formats, as explained in this.centerMapOnGeoJson
    */
    getPolyline () {
      const twoFormats: any = { onlyNumber: [], withObjects: [] };
      const object: any = this.route?.geometry?.coordinates || this.route?.features[0]?.geometry?.coordinates;

      for (let i = 0; i < object.length; i++) {
        const [lon, lat] = object[i];
        twoFormats.onlyNumber.push([lat, lon]);
        twoFormats.withObjects.push({ lat, long: lon });
      }

      return twoFormats;
    }

    /*
      Method that creates a LeafletIcon for a post, with a custom class and
      content (the distance in user preferred unit)
    */
    createPostIcon (value: number) {
      return this.$L.divIcon({
        className: 'leaflet-marker-icon kilometric',
        html: `${value}`,
      });
    }

    /*
      Switcher that returns an asset to be used to create a Leaflet Icon
    */
    createPoiIcon (value: number) {
      switch (value) {
        case 0: return require('~/assets/icons/map/nature.svg');
        case 2: return require('~/assets/icons/map/Pinpanorama.svg');
        case 3: return require('~/assets/icons/map/history.svg');
        case 4: return require('~/assets/icons/map/warning.svg');
        case 5: return require('~/assets/icons/map/Pininfo.svg');
        case 10: return require('~/assets/icons/map/handisport.svg');
        case 11: return require('~/assets/icons/map/canitrail.svg');
      }
    }

    /* Method that uses a Leaflet function to create an icon for POIs */
    createPoiIconLeaflet (source: number) {
      return this.$L.icon({
        iconUrl: this.createPoiIcon(source),
        iconSize: [40, 40],
        iconAnchor: [16, 37],
        className: 'resetProviderClass',
      });
    }

    /* Same logic than this.createPoiIconLeaflet with a given asset */
    createProviderIcon (source: string) {
      return this.$L.icon({
        iconUrl: source,
        iconSize: [50, 50],
        iconAnchor: [16, 37],
        className: 'resetProviderClass',
      });
    }

    /*
      Creates icon of provider marker from template, using given provider type
      to use Leaflet methods
    */
    adaptedProviderIcon (provider: Types.Provider) {
      switch (provider.type) {
        case 'FOOD': return this.createProviderIcon('/icons/PinProvidersEat.svg');
        case 'TODOTOSEE': return this.createProviderIcon('/icons/PinProvidersTodotosee.svg');
        case 'HOSTING': return this.createProviderIcon('/icons/PinProvidersHosting.svg');
        case 'SHOP': return this.createProviderIcon('/icons/PinProvidersShop.svg');
        case 'SERVICE': return this.createProviderIcon('/icons/PinProvidersService.svg');
        case 'EMERGENCY' : return this.createEmergencyIcon(provider.title);
      }
      return this.providersIcon;
    }

    createEmergencyIcon (title: string) {
      return this.$L.divIcon({
        className: 'resetProviderClass',
        html: '<div class="relative">' +
          '<img class="absolute z-10" src="/icons/PinProvidersEmergency.svg"/>' +
          '<span class="absolute z-20 text-center left-0 right-0 text-white font-bold" style="top:7px">' + title + '</span>' +
          '</div>',
        iconSize: [45, 50],
        iconAnchor: [16, 37],
      });
    }

    /*
      This method is called in mounted and in resize event listener.
      In mobile devices, we don't want the user to be able to scroll like a
      scrollWheelZoom type
    */
    handleWheel () {
      if (process.client) {
        if (window.innerWidth < 321) {
          this.isXsDevice = true;
        } else {
          this.isXsDevice = false;
        }
      }
    }
}
